import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';

interface FormattedValueProps {
  precision: number;
  value: any;

  e2e?: string;
}

export const FormattedValue: FC<FormattedValueProps> = ({ precision, value, e2e }) => {
  const { formatNumber } = useIntl();
  const formatValue = useCallback(
    (val: any) =>
      val === undefined ? '_' : typeof val === 'number' ? formatNumber(val, { maximumFractionDigits: precision }) : val,
    [formatNumber, precision],
  );
  return <span data-e2e={e2e}>{formatValue(value)}</span>;
};

FormattedValue.displayName = 'FormattedValue';
